// Production fallbacks (audit 2026-06-17): the CI build does `rm -rf .env*`
// (cicd.yaml) and passes no --build-arg, so NEXT_PUBLIC_* are undefined at
// build time — which broke Google login (URL became `undefined/auth/sns/...`
// -> 404) and Pusher realtime. These `|| <prod value>` fallbacks only apply
// when the build env is unset, so they are a no-op once CI injects the vars.
// Values from .env.example / confirmed prod domains. PROPER FIX: restore the
// env injection in cicd.yaml (provide NEXT_PUBLIC_* to the docker build).
export const API_ADMIN = process.env.API_ADMIN || "https://api.ceeq.io/api/admin";
// API_CLIENT backs API_SERVICES_NAME.WEB, whose call sites are the user-scoped
// auth/profile endpoints (`/login`, `/register`, `/company`, `/forgot-password`,
// `/reset-password`, `/email/verify`, `/email/resend`, `/meeting-host`). On the
// backend these all live under `api/users/*`, so the base must include `/users`
// — without it every WEB call 404s ("The route api/login could not be found.").
export const API_CLIENT =
  process.env.API_CLIENT || "https://api.ceeq.io/api/users";
export const CALLBACK_URL = process.env.CALLBACK_URL || "https://ceeq.io";
export const CALLBACK_URL_BE = process.env.CALLBACK_URL_BE || "https://api.ceeq.io";
export const API_PUBLIC = process.env.API_PUBLIC || "https://api.ceeq.io/api";
export const BASE_API = process.env.BASE_API || "https://api.ceeq.io";
export const PUSHER_APP_KEY = process.env.PUSHER_APP_KEY || "c883601c33632b50e53d";
export const PUSHER_CLUSTER = process.env.PUSHER_CLUSTER || "ap1";
// Must match APP_ENV's NEXT_PUBLIC_MEETING_URL (https://meeting.ceeq.io). This
// value is not cosmetic: booking-page slugs are STORED in the database as a
// full URL built from it (modules/calendar/create/index.tsx) and looked up by
// exact match (ScheduleService::getSchedulesBySlug), so a mismatch between the
// build-time value and the stored value orphans existing booking links.
export const MEETING_URL =
  process.env.MEETING_URL || "https://meeting.ceeq.io";
